import { RegisteredHierarchy } from "../../../../../core/models/configuration-system";
import { DataTable } from "../../data-table.interface";
const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'editar',
    hasVisibleCondition: (element: RegisteredHierarchy[]): boolean => element.length >= 1
  },
  {
    icon: "trash",
    tooltip: "Eliminar",
  }
];

export const securityStockByHierarchy: DataTable = {
    searchText: 'Buscar jerarquía',
    export: false,
    filter: false,
    dialogHability: false,
    disabled: false,
    partialField: '',
    checkbox: true,
    checkboxHeader: false,
    iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: RegisteredHierarchy, selection: RegisteredHierarchy[]) => {
      if (selection.length > 0 && row && selection[0].id) {
        return selection.length === 1 && row.id === selection[0].id && selection[0].securityStock!=null? false : true;
      } else {
        return row.id? false: true;
      }
    },
    columns: [
      {
        title: 'Jerarquía',
        name: 'hierarchyDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.hierarchyDescription
      },
      {
        title: 'Código',
        name: 'hierarchyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.hierarchyCode
      },
      {
        title: 'Stock de seguridad',
        name: 'securityStock',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: any) => element.securityStock
      }
    ]
  };
